import { Injectable } from '@angular/core';
import { LoadingService } from '../../common/layout/loading.service';
import { GenericErrorHandlerService } from './generic-error-handler.service';
import { NotificationService } from '../../common/layout/notification.service';
import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GenericRequestHandlerService {

    constructor(
        private loadingService: LoadingService,
        private errorService: GenericErrorHandlerService,
        private notification: NotificationService
    ) {
    }

    callRequest(request: Observable<any>, successMessage?: string): Promise<any> {
        this.loadingService.start();
        return new Promise<any>((resolve, reject) => {
            request.subscribe(
                response => {
                    this.loadingService.stop();
                    if (!isNullOrUndefined(successMessage)) {
                        this.notification.success(successMessage);
                    }
                    resolve(response);
                },
                error => {
                    this.errorService.handleError(error);
                    this.loadingService.stop();
                    reject(error);
                }
            );
        });
    }
}
